import {
  addFileProcessingUrl,
  getFileProcessingUrl,
  updateFileProcessingById,
} from "./constants";
import base from "../middlewares/interceptors";
import { getConfig } from "../config/runtimeConfig";

export const getFileProcessing = async () => {
  try {
    const response = await base.get(getFileProcessingUrl);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const getFileProcessingDetail = async ({
  currentFileProcessingId,
}: any) => {
  try {
    const response = await base.get(
      `${getFileProcessingUrl}/${currentFileProcessingId}`
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const addFileProcessing = async ({ payload }: any) => {
  try {
    const response = await base.post(addFileProcessingUrl, payload);
    return response.data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const updateFileProcessing = async ({
  currentFileProcessingId,
  payload,
}: any) => {
  try {
    const response = await base.put(
      `${updateFileProcessingById}/${currentFileProcessingId}`,
      payload
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const deleteFileProcessing = async (currentFileProcessingId: number) => {
  try {
    const response = await base.delete(
      `${updateFileProcessingById}/${currentFileProcessingId}`
    );
    return { response: response.data, status: response.status };
  } catch (error) {
    console.error(error);
  }
};

export const getPaginatedFileProcessing = async ({
  page,
  pSize,
  searchTerm,
  isActive = "true",
  signal,
}: {
  page?: number;
  pSize?: number;
  searchTerm?: string;
  isActive?: string;
  signal?: AbortSignal;
}) => {
  try {
    const pageN = page == null ? getConfig("REACT_APP_DEFAULT_PAGE", "1") : page;
    const pageS =
      pSize == null ? getConfig("REACT_APP_DEFAULT_PAGE_SIZE", "25") : pSize;

    // Build base URL with required parameters
    let requestUrl = `${getFileProcessingUrl}/all/pages?page=${pageN}&size=${pageS}`;

    // Conditionally add is_active parameter only when it's "true" or "false" (not "all")
    if (isActive && isActive !== "all") {
      requestUrl += `&is_active=${isActive}`;
    }

    // Add search parameter if searchTerm is provided and has minimum 3 characters
    if (searchTerm && searchTerm.trim().length >= 3) {
      requestUrl += `&resource_type=${encodeURIComponent(searchTerm.trim())}`;
    }

    const response = await base.get(requestUrl, {
      signal, // Add abort signal for request cancellation
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

/**
 * Reactivate file processing attribute
 * @param fileProcessingId - The ID of the file processing attribute to reactivate
 * @returns Promise with reactivation result
 */
export const reactivateFileProcessing = async (
  fileProcessingId: string | number
) => {
  try {
    const response = await base.put(
      `${updateFileProcessingById}/${fileProcessingId}/reactivate`
    );
    return response.data;
  } catch (error) {
    console.error("Error reactivating file processing attribute:", error);
    throw error;
  }
};
